import React from 'react'
import NotificationsGrid from './Components/NotificationsGrid';

function Notifications() {
  return <NotificationsGrid/>
}
export {Notifications};